import { createFeatureSelector, createSelector } from '@ngrx/store';
import { NotificationState } from '../reducer/notification.reducer';

export const selectNotificationState = createFeatureSelector<NotificationState>('notification');

export const selectAllNotifications = createSelector(
  selectNotificationState,
  (state: NotificationState) => state.notifications,
);

export const selectActiveNotifications = createSelector(
  selectAllNotifications,
  (notifications) => notifications,
);

export const selectNotificationCount = createSelector(
  selectAllNotifications,
  (notifications) => notifications.length,
);

export const selectHasNotifications = createSelector(selectNotificationCount, (count) => count > 0);
